import { useState, useEffect, useCallback } from 'react';

// Densità globale dell'interfaccia: 'comfortable' | 'compact'.
// Persistita su localStorage e applicata via data-density su <html>.
export function useDensity() {
  const [density, setDensity] = useState(() => localStorage.getItem('eden-density') || 'comfortable');

  useEffect(() => {
    document.documentElement.dataset.density = density;
    localStorage.setItem('eden-density', density);
  }, [density]);

  const toggle = useCallback(() => setDensity(d => (d === 'compact' ? 'comfortable' : 'compact')), []);
  return { density, toggle, compact: density === 'compact' };
}
